module.exports = __webpack_public_path__ + "static/media/emmaus.23d62a28.svg";